// Shared helpers for reading (and decrypting) session documents.
import { collection, getDocs, orderBy, query, where } from 'firebase/firestore';
import { db } from '../firebase';
import { decryptData, getStoredPassphrase } from './encryption';

// Decrypt one session doc. Handles both formats:
//  - old: the entire session was encrypted into `data`
//  - new: only setup/powerData/damperSetup/notes are inside `data`
// Throws if the passphrase is wrong.
export const decryptSession = (session, passphrase) => {
  if (!session.encrypted) return session;
  const decryptedData = decryptData(session.data, passphrase);
  if (decryptedData.vehicleId && decryptedData.eventId) {
    return { id: session.id, ...decryptedData };
  }
  return { id: session.id, ...session, ...decryptedData };
};

// Decrypt a list of sessions, leaving any that fail as-is (still encrypted).
export const decryptSessions = (sessions, passphrase) => {
  if (!passphrase) return sessions;
  return sessions.map(session => {
    if (!session.encrypted) return session;
    try {
      return decryptSession(session, passphrase);
    } catch (error) {
      console.error(`Failed to decrypt session ${session.id}:`, error);
      return session;
    }
  });
};

// All sessions of an event, newest first, decrypted with the stored passphrase.
export const loadEventSessions = async (dataUid, eventId) => {
  const snap = await getDocs(query(
    collection(db, `users/${dataUid}/sessions`),
    where('eventId', '==', eventId),
    orderBy('time', 'desc')
  ));
  const sessions = snap.docs.map(d => ({ id: d.id, ...d.data() }));
  return decryptSessions(sessions, getStoredPassphrase());
};
